import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";

export default function InvoiceDetailsSkeleton() {
  const rows = Array.from({ length: 10 });
  const cols = Array.from({ length: 16 });

  return (
    <Box sx={{ borderRadius: "12px", overflow: "hidden" }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {cols.map((_, i) => (
                <TableCell key={i}>
                  <Skeleton height={24} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{ bgcolor: rowIndex % 2 ? "#f7f7f7" : "#fff" }}
              >
                {cols.map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton height={24} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
